<template>
  <div class="about">
    <!-- Hero Section -->
    <section class="hero">
      <div class="container">
        <h1>About Roadlink GLB</h1>
        <p>Learn more about our mission, values, and the team behind our international trade platform.</p>
      </div>
    </section>

    <!-- Content Section -->
    <section class="content-section">
      <div class="container">
        <div class="about-grid">
          <div class="about-card">
            <div class="about-content">
              <h3>Our Mission</h3>
              <p>At Roadlink GLB, our mission is to simplify international market entry for businesses of all sizes. We believe that geographical boundaries should not limit business growth and opportunity.</p>
              <p>Through our comprehensive platform, we connect businesses with the resources, insights, and partnerships needed to succeed in global markets.</p>
            </div>
          </div>
          
          <div class="about-card">
            <div class="about-content">
              <h3>Our Values</h3>
              <ul>
                <li><strong>Integrity:</strong> We operate with transparency and honesty in all our dealings.</li>
                <li><strong>Innovation:</strong> We continuously improve our services to meet evolving market needs.</li>
                <li><strong>Collaboration:</strong> We believe in the power of partnerships to drive mutual success.</li>
                <li><strong>Excellence:</strong> We strive for the highest standards in everything we do.</li>
              </ul>
            </div>
          </div>
          
          <div class="about-card">
            <div class="about-content">
              <h3>Our Story</h3>
              <p>Founded in 2010, Roadlink GLB has grown from a small consulting firm to a comprehensive international trade platform. Our journey began with helping local businesses navigate the complexities of entering Southeast Asian markets.</p>
              <p>Over the years, we've expanded our services and geographic reach, building a network of partners across 17+ countries and serving over 70,000 enterprises.</p>
            </div>
          </div>
          
          <div class="about-card">
            <div class="about-content">
              <h3>Our Team</h3>
              <p>Our team consists of experienced professionals with diverse backgrounds in international trade, market research, legal compliance, and business development.</p>
              <p>We combine local market expertise with global perspectives to deliver tailored solutions for each client's unique needs.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Stats Section -->
    <section class="stats">
      <div class="container">
        <div class="section-title">
          <h2>Our Impact</h2>
          <p>Numbers that speak to our commitment and success in facilitating international trade.</p>
        </div>
        
        <div class="stats-grid">
          <StatCard 
            icon="fas fa-globe"
            number="17+"
            description="Countries/Regions with global network resources" />
            
          <StatCard 
            icon="fas fa-calendar-alt"
            number="13 Years"
            description="Of international service implementation experience" />
            
          <StatCard 
            icon="fas fa-building"
            number="70,000+"
            description="Enterprises served" />
            
          <StatCard 
            icon="fas fa-handshake"
            number="95%"
            description="Client satisfaction rate" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import StatCard from '../components/modals/shared/StatCard.vue'

export default {
  name: 'About',
  components: {
    StatCard
  }
}
</script>

<style scoped>
.hero {
  background: linear-gradient(rgba(26, 58, 95, 0.85), rgba(26, 58, 95, 0.9)), url('https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80');
  background-size: cover;
  background-position: center;
  color: white;
  padding: 80px 0;
  text-align: center;
}

.hero h1 {
  font-size: 42px;
  margin-bottom: 20px;
}

.hero p {
  font-size: 18px;
  max-width: 700px;
  margin: 0 auto 30px;
}

.content-section {
  padding: 80px 0;
  background-color: white;
}

.about-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.about-card {
  background-color: #f5f7fa;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.about-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.about-content h3 {
  color: #1a3a5f;
  margin-bottom: 20px;
  font-size: 24px;
}

.about-content p {
  margin-bottom: 15px;
  line-height: 1.6;
}

.about-content ul {
  list-style: none;
}

.about-content li {
  margin-bottom: 10px;
  padding-left: 20px;
  position: relative;
  line-height: 1.6;
}

.about-content li:before {
  content: "•";
  color: #4dabf7;
  font-weight: bold;
  position: absolute;
  left: 0;
}

.stats {
  padding: 80px 0;
  background-color: #f5f7fa;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

@media (max-width: 768px) {
  .hero h1 {
    font-size: 32px;
  }
  
  .hero p {
    font-size: 16px;
  }
  
  .content-section {
    padding: 50px 0;
  }
}
</style>